<div
  style="height: 64px; width: 100%"
  [ngClass]="{ 'bg-[#FBFAFC]': !areWelcomePage() }"
  class="rounded-t-[30px] py-4 px-4 flex items-center justify-between"
>
  <!-- SECTION LEFT -->
  <div class="flex items-center justify-start w-full">
    <!-- back button -->
    @if (showBackButton$ | async) {
      @if (onClickBackToUrl$ | async; as url) {
        <button
          mat-icon-button
          (click)="onClickGoBackButton(url)"
          class="mr-3"
          [attr.aria-label]="'GENERAL.paginaPrecedente' | translate"
        >
          <mat-icon fontIcon="arrow_back"></mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          (click)="onClickGoBackButton()"
          class="mr-3"
          [attr.aria-label]="'GENERAL.paginaPrecedente' | translate"
        >
          <mat-icon fontIcon="arrow_back"></mat-icon>
        </button>
      }
    }

    <!-- title -->
    @if (title$ | async; as title) {
      @if (!areWelcomePage()) {
        <h1 class="text-2xl font-medium mr-3">
          {{ title$ | async | translate }}
        </h1>
      }
    }

    <!-- custom template ES: "addButtonTemplate"-->
    @if (template$ | async; as customTemplate) {
      <ng-container [ngTemplateOutlet]="customTemplate"></ng-container>
    }
  </div>

  <!-- SECTION RIGHT -->

  @if (userLogged$ | async) {
    <nav
      class="flex items-center justify-between"
      attr.aria-label="{{ 'GENERAL.navigazioneUtente' | translate }}"
    >
      @let s = selectedStruttura$ | async;
      @if (s) {
        <p class="px-3 font-semibold whitespace-nowrap">
          <span class="sr-only">Struttura: </span>{{ s?.nome }}
        </p>
      }
      <!--  user menu -->
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        matTooltip="{{ 'GENERAL.apriMenuProfilo' | translate }}"
        [attr.aria-label]="'GENERAL.apriMenuProfilo' | translate"
        class="relative"
      >
        <mat-icon
          class="material-icons-outlined"
          fontIcon="person"
        ></mat-icon>
        @let n = notificationsNum$ | async;
        @if (selectedStruttura$ && n > 0) {
          <div class="notifications-circle">
            <span>{{ n }}</span>
          </div>
        }
      </button>
      <mat-menu
        #menu="matMenu"
        class="min-w-92.5! tracking-[0.1px]!"
        (closed)="resetStrutturaSelection()"
      >
        <!-- info  -->
        <div class="p-3 pb-1">
          <div class="flex flex-row font-normal items-center">
            <!--avatar -->
            <div>
              <div class="avatar text-on-primary-container">
                {{
                  getAvatar(
                    (userLogged$ | async)?.nome,
                    (userLogged$ | async)?.cognome
                  )
                }}
              </div>
            </div>
            <div class="flex flex-col w-full pl-3">
              <!--username and surname -->
              <p class="text-base">
                {{
                  (userLogged$ | async)?.nome +
                    ' ' +
                    (userLogged$ | async)?.cognome
                }}
              </p>

              @if (currentAppId !== 'amministrazione') {
                <!-- selected struttura section -->
                @if (selectedStruttura$ | async) {
                  <div>
                    <span class="text-sm">{{
                      (selectedStruttura$ | async)?.ruoli?.length > 1
                        ? 'Ruoli:'
                        : 'Ruolo:'
                    }}</span>
                    <span class="font-bold text-sm">
                      @for (
                        ruolo of (selectedStruttura$ | async)?.ruoli;
                        track $index;
                        let last = $last
                      ) {
                        {{ ruolo.nome }}{{ last ? '' : ', ' }}
                      }
                    </span>
                  </div>
                  <div>
                    <span class="text-sm">{{
                      (selectedStruttura$ | async)?.lavori?.length > 1
                        ? 'Lavori:'
                        : 'Lavoro:'
                    }}</span>
                    <span class="font-bold text-sm">
                      @for (
                        lavoro of (selectedStruttura$ | async)?.lavori;
                        track lavoro.id;
                        let last = $last
                      ) {
                        {{ lavoro.nome }}{{ last ? '' : ', ' }}
                      }
                    </span>
                  </div>
                  <div
                    class="flex flex-row justify-between text-sm items-center"
                  >
                    <div>
                      <span class="text-sm">Struttura:</span>
                      <span class="font-bold text-sm">
                        {{ (selectedStruttura$ | async)?.nome }}</span
                      >
                    </div>
                    @if ((userLogged$ | async)?.strutture?.length > 1) {
                      <!-- change struttura -->
                      <a
                        [attr.aria-label]="
                          'GENERAL.cambiaStruttura' | translate
                        "
                        class="pl-3 ml-auto underline! text-primary font-semibold!"
                        href="javascript:void(0);"
                        (click)="
                          $event.stopPropagation(); showStrutturaSelection()
                        "
                        >{{ 'Cambia ' | translate }}</a
                      >
                    }
                  </div>
                }
              }
            </div>
          </div>

          @if (showStruttureList && struttureOptItems.length > 0) {
            <div class="p-3 font-medium" [formGroup]="strutturaForm">
              <p>Seleziona struttura:</p>
              <div class="pt-3" role="radiogroup">
                <siat-radio-field
                  [formGroup]="strutturaForm"
                  controlName="selectedStruttura"
                  id="selectedStruttura"
                  [displayInline]="true"
                  labelClass="font-semibold"
                  name="selectedStruttura"
                  [data]="struttureOptItems"
                  [hideMarker]="true"
                >
                </siat-radio-field>
              </div>
            </div>
            <mat-divider class="mx-3!"></mat-divider>
          }
          <div class="pl-1 pt-2">
            <!-- disabled account item -->
            <button mat-menu-item disabled>
              <mat-icon class="material-icons-outlined"
                >account_circle</mat-icon
              >
              Utenza
            </button>
            <!-- disabled settings item -->
            <button
              mat-menu-item
              aria-label="Controlla aggiornamenti app"
              (click)="checkUpdate()"
            >
              <mat-icon class="material-icons-outlined">update</mat-icon>
              Controlla aggiornamenti app
            </button>
            @if (
              !userProvider.isAdminUser ||
              userProvider.userStruttureList?.length > 0
            ) {
              <button mat-menu-item [routerLink]="'/home/notifiche'">
                <mat-icon class="material-icons-outlined"
                  >notifications</mat-icon
                >
                Notifiche
              </button>
            }
            <button
              mat-menu-item
              aria-label="Supporto"
              (click)="openSupporto()"
            >
              <mat-icon class="material-icons-outlined">support_agent</mat-icon>
              Supporto
            </button>
            <!-- Go to Apps -->
            @if (!areWelcomePage()) {
              <button
                mat-menu-item
                (click)="goToAppsPage()"
                class="mt-3 col-span-1"
                [attr.aria-label]="'Torna alla selezione delle app'"
              >
                <mat-icon class="material-icons-outlined"> home </mat-icon>
                Menu iniziale
              </button>
            }
            <!-- logout -->
            <button
              mat-menu-item
              (click)="logout()"
              [attr.aria-label]="'Logout'"
            >
              <mat-icon
                class="material-icons-outlined"
                [svgIcon]="'export'"
              ></mat-icon>
              Esci
            </button>
          </div>
        </div>
      </mat-menu>
    </nav>
  }
</div>
